import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { HttpClientHelperService } from './http-client-helper.service';
import { GetNotificationsParams, JsonPatchOperation, NotificationInboxDto, NotificationInboxPagedDto } from '../notifications/models/notification.interface';

@Injectable({
    providedIn: 'root'
})
export class ApiClientNotificationsService {

    private readonly baseUrl = 'notification-center/inbox';

    constructor(private http: HttpClientHelperService) {}

    getNotifications(params?: GetNotificationsParams): Observable<NotificationInboxPagedDto> {
        let httpParams = new HttpParams();
        if (params?.IsRead !== undefined) {
            httpParams = httpParams.set('IsRead', params.IsRead);
        }
        if (params?.NotificationType) {
            httpParams = httpParams.set('NotificationType', params.NotificationType);
        }
        if (params?.NextPage) {
            httpParams = httpParams.set('NextPage', params.NextPage);
        }
        if (params?.PageSize !== undefined) {
            httpParams = httpParams.set('PageSize', params.PageSize);
        }
        return this.http.invokeGetAuth<NotificationInboxPagedDto>(this.baseUrl, httpParams);
    }

    patchNotification(id: string, operations: JsonPatchOperation[]): Observable<NotificationInboxDto> {
        return this.http.invokePatchAuth<NotificationInboxDto>(`${this.baseUrl}/${id}`, operations);
    }

    deleteNotification(id: string): Observable<void> {
        return this.http.invokeDeleteAuth<void>(`${this.baseUrl}/${id}`);
    }
}
